<template>
  <div :class="$style.container">
    <Title title="域名详情"></Title>

    <Loading :loading="loading" :text="loadingText" :class="$style.content">
      <Item title="域名:">
        {{ dataInfo.domainName }}
        <Button type="text" @click="lookCertificate">查看证书</Button>
        <Button type="text" @click="downloadCertificate">下载证书</Button>
      </Item>

      <Item title="注册时间:">
        {{ dataInfo.regTime }}
      </Item>

      <Item title="过期时间:">
        {{ dataInfo.expTime }}
        <Button type="text" @click="toRenew">续费</Button>
      </Item>

      <Item title="域名状态:" :class="$style.status_list">
        <div :class="$style.status_inner">
          <div v-for="item in dataInfo.statusList" :key="item.name">
            <span>{{ item.desc }}</span>
            <span style="color: #1c9cdf; margin-left: 10px">
              ({{ item.name }})
            </span>
          </div>
        </div>

        <Button type="text" @click="setStatusVisible(true)">
          域名状态说明
        </Button>
      </Item>

      <Item title="域名所有人:">{{ dataInfo.owner }}</Item>

      <Item title="实名证件类型:">{{ dataInfo.typeName }}</Item>

      <Item title="实名证件号码:">{{ dataInfo.num }}</Item>
    </Loading>

    <!-- 证书弹窗 -->
    <template v-if="imageVisible">
      <el-dialog visible title="预览证书" @close="setImageVisible(false)">
        <div :class="$style.image_wrap">
          <img :class="$style.image" :src="image" alt="" />
        </div>
      </el-dialog>
    </template>

    <!-- 状态说明 -->
    <el-dialog
      :visible="statusVisible"
      title="域名状态说明"
      @close="setStatusVisible(false)"
    >
      <div :class="$style.status_wrap">
        <div :class="$style.item">
          <div :class="$style.name" style="margin-right:50px">域名状态码</div>
          <div :class="[$style.desc, $style.desc_top]">域名状态描述</div>
        </div>
        <div
          v-for="item in dataInfo.domainStatusCaptionList"
          :key="item.name"
          :class="$style.item"
        >
          <div :class="$style.name" style="margin-right:50px">{{ item.name }}</div>
          <div :class="$style.desc">{{ item.desc }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDomainDetail, getDownloadDomainPic, createShopping } from "@server";

export default {
  name: "DomainDetail",
  data() {
    return {
      dataInfo: {},

      loading: false,
      loadingText: "",
      image: "",
      imageVisible: false,

      statusVisible: false,
    };
  },
  methods: {
    async getDomainDetail(id = "") {
      const res = await getDomainDetail({ domainId: id });
      if (res.code === 200) {
        this.dataInfo = res.data;
      }
    },

    setImageVisible(v) {
      this.imageVisible = v;
    },

    setStatusVisible(v) {
      this.statusVisible = v;
    },

    async lookCertificate() {
      if (!this.domainId) {
        this.$message({ message: "域名id不存在", type: "warning" });
        return;
      }

      if (this.image) {
        this.setImageVisible(true);
        return;
      }

      this.loading = true;
      this.loadingText = "正在加载证书...";
      const params = { domainId: this.domainId };
      let res = await getDownloadDomainPic(params);

      try {
        const enc = new TextDecoder("utf-8");
        res = JSON.parse(enc.decode(new Uint8Array(res)));
        this.image = res.data;
        this.setImageVisible(true);
        this.loading = false;
        this.loadingText = "";
      } catch (error) {
        const _data = new Uint8Array(res).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        );
        res = "data:image/png;base64," + btoa(_data);
        this.image = res;
        this.setImageVisible(true);
        this.loading = false;
        this.loadingText = "";
      }
    },

    async downloadCertificate() {
      if (!this.image) {
        await this.lookCertificate();
      }

      this.download();
    },

    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    download() {
      const data = this.dataURLtoBlob(this.image);
      const type = data.type.split("/")[1];
      const imageUrl = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.setAttribute("href", imageUrl);
      a.setAttribute("download", `${this.dataInfo.domainName}证书信息.${type}`);
      a.setAttribute("target", "_blank");
      const clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },

    async toRenew() {
      this.loading = true;

      const data = {
        goodsNames: [this.dataInfo.domainName],
        operateType: 1,
      };
      const res = await createShopping(data);

      if (res.code === 200) {
        this.$message({ message: "添加成功!", type: "success" });
        setTimeout(() => {
          window.location.href = "/cart";
        }, 500);
      }
      this.loading = false;
    },

    lookDomainStatus() {},
  },
  created() {
    const { query } = this.$route;

    this.domainId = query.id;
    this.getDomainDetail(query.id);
  },
};
</script>

<style lang='scss' module scoped>
.container {
  min-height: 360px;
  padding: rem(50);
  background: $white;
  box-shadow: $box-shadow;

  :global {
    ::v-deep .gl-item {
      margin-bottom: 30px;

      .gl-item__name {
        min-width: 120px;
        padding-right: 20px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(61, 61, 61, 0.85);
        text-align: right;
      }

      .gl-item__right {
        font-size: 14px;
        color: rgba(61, 61, 61, 0.8);
      }
    }

    .gl-button--text {
      color: $theme-color;
      margin-left: 25px;
    }

    .el-dialog {
      width: 900px;
    }
  }

  .content {
    padding-left: 200px;
  }

  .status_list {
    align-items: flex-start;
  }
  .status_inner {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .image_wrap,
  .status_wrap {
    width: 100%;
    max-height: 75vh;
    overflow-y: auto;
    overflow-y: overlay;
    @include scrollbar();

    .image {
      width: 100%;
      object-fit: cover;
    }
  }

  .status_wrap {
    .item {
      @include flex();
      gap: 100px;
      font-size: 14px;
      color: rgba(61, 61, 61, 0.85);
      line-height: 50px;
      background: $white;

      &:nth-child(odd) {
        background: #f9f9f9;
      }

      .name {
        flex: 1;
        text-align: right;
        font-weight: bold;
      }

      .desc {
        flex: 1;
      }

      .desc_top {
        font-weight: bold;
      }
    }
  }
}
</style>
